export default '<div class="overlay overlay--is-hidden"></div>';
